var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-intersect',{on:{"enter":_vm.onEnter,"leave":_vm.onLeave}},[_c('div',{class:_vm.isElementEntered ? _vm.animatedClass : ''},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }